import React, {useState, useEffect} from 'react';
import './BoxChamp.css';
import { apiLink, classementAPI, getLongNameChamp } from '../variables';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { 
    IoIosArrowUp 
} from "react-icons/io";

var XMLParser = require('react-xml-parser');

function BoxChamp({championnat}) {
    const navigate = useNavigate();
    const [currentOnglet, setCurrentOnglet] = useState(1);
    const [classement, setClassement] = useState(null);
    const [matchs, setMatchs] = useState(null);
    const [parsedMatch, setParsedMatch] = useState([]);
    const [currentDay, setCurrentDay] = useState(1);

   

    useEffect(() =>  {
        getClassement()
        getMatchs();
    }, [])

    const getClassement = async () => {
        const link = classementAPI.find(item => item.for == championnat).link;
        if (link !== '') {
            axios
            .get(link, {
                "Content-Type": "application/xml; charset=utf-8"
            })
            .then(function(res) {
                var data = new XMLParser().parseFromString(res.data).children;
                setClassement(data);
            })
            .catch(function(error) {
                console.log(error);
            });
        } 
    }

    const getMatchs = async () => {
        const link = apiLink.find(item => item.for == championnat).link;
        if (link !== '') {
            axios
            .get(link, {
                "Content-Type": "application/xml; charset=utf-8"
            })
            .then(function(res) {
                var data = new XMLParser().parseFromString(res.data).children;
                setMatchs(data);
                parseMatch(data);
                calculateCurrentDay(data)
            })
            .catch(function(error) {
                console.log(error);
            });
        } 
    }

    const parseMatch = (data, day = currentDay) => {
        let arrayDate = [];
        const tmpDate = [];
        // on insère les dates
        data.map((item) => {
            let tour = item.getElementsByTagName('libelle')[0].value.toString();
            tour = parseInt(tour.split('°')[1].split(' ')[0]);
            if (day == tour) {
                let date = item.getElementsByTagName('datereelle')[0].value.toString();
                // date = date.split('du')[1].trim();
                date = new Date(date.split('/')[2] + '-' + date.split('/')[1] + '-' + date.split('/')[0]);
                if (!tmpDate.includes(date.toString())) {
                    arrayDate.push({date: date, dataIndex: []});
                    tmpDate.push(date.toString());
                }
            }
        })

        // On tri le tableau par ordre croissant
        arrayDate.sort((a, b) => a.date - b.date);

        // on insère les matchs par date
        arrayDate.forEach(function(obj) {
            data.map((item, index) => {
                let tour = item.getElementsByTagName('libelle')[0].value.toString();
                tour = parseInt(tour.split('°')[1].split(' ')[0]);
                if (day == tour) {
                    let dateMatch = item.getElementsByTagName('datereelle')[0].value.toString();
                    dateMatch = new Date(dateMatch.split('/')[2] + '-' + dateMatch.split('/')[1] + '-' + dateMatch.split('/')[0]);
                    if (obj.date.getTime() === dateMatch.getTime()) {
                        obj.dataIndex.push(index);
                    }
                }
            })
        })
        setParsedMatch(arrayDate);
    }

    const getCurrentHighestDay = (matchs) => {
        const today = new Date();
        let currentHighestDay = 1;

        matchs.forEach((match) => {
            // on récupère la date du match
            let date = match.getElementsByTagName('datereelle')[0].value.toString();
            date = new Date(date.split('/')[2] + '-' + date.split('/')[1] + '-' + date.split('/')[0]);
            // on récupère la journée
            const day = parseInt(match.getElementsByTagName('libelle')[0].value.toString().split('°')[1].split(' ')[0]);

            // on veut connaître la journée atteinte à la date d'aujourd'hui
            // si la date du match n'est toujours pas arrivé
            // alors on passe au suivant;
            if (date > today) return;

            if (day > currentHighestDay) {
                currentHighestDay = day;
            }
        });

        return currentHighestDay;
    }

    const calculateCurrentDay = (matchs) => {
        const today = new Date();
        const matchParsed = [];
        const currentHighestDay = getCurrentHighestDay(matchs);

        // Pour chaque match
        matchs.forEach((match) => {
            // on récupère la date du match
            let date = match.getElementsByTagName('datereelle')[0].value.toString();
            date = new Date(date.split('/')[2] + '-' + date.split('/')[1] + '-' + date.split('/')[0]);
            // on récupère la journée
            const day = parseInt(match.getElementsByTagName('libelle')[0].value.toString().split('°')[1].split(' ')[0]);
            // si la date est < today alors on ne la compte pas dans le calcul
            if (date < today + 1) return;
            // si la journée du match est déjà passé alors on ne la compte pas dans le calcul
            // cette ligne est pour pallier aux exceptions où certains matchs se jouent à une journée X avec une date éloignée des autres
            if (day < currentHighestDay) return;
            // on push
            matchParsed.push({
                date,
                day
            });
        });

        // Si tous les matchs ont été joués
        // on retourne la dernière journée
        if (matchs.length > 0 && matchParsed.length === 0) {
            return getMaxDayChampionnat();
        }

        const neareastMatch = matchParsed.sort((a, b) => {
            const dateDifferenceA = Math.abs(a.date - today);
            const dateDifferenceB = Math.abs(b.date - today);
        
            // Si les dates sont égales, comparez par jour
            if (dateDifferenceA === dateDifferenceB) {
                return a.day - b.day;
            }
        
            return dateDifferenceA - dateDifferenceB;
        })[0];
        
        // on calcule la date la plus proche
        // const neareastMatch = matchParsed.reduce((a, b) => Math.abs(a.date - today) < Math.abs(b.date - today) ? a : b) || 1;
        // on change à la date la plus proche
        return handleChangeDay(neareastMatch.day, matchs);
    }


    const getMaxDayChampionnat = (m = matchs) => {
        let maxDayChampionnat = 1; 
        m.forEach((match) => {
            // on récupère la journée
            const day = parseInt(match.getElementsByTagName('libelle')[0].value.toString().split('°')[1].split(' ')[0]);
            if (day > maxDayChampionnat) {
                maxDayChampionnat = day;
            }
        });
        return maxDayChampionnat;
    }

    const info = (index, value) => {
        return classement[index].getElementsByTagName(value)[0].value;
    }

    const infoMatch = (index, value) => {
        return matchs[index].getElementsByTagName(value)[0].value;
    }

    const handleChangeDay = (day , m = matchs) => {
        let maxDayChampionnat = getMaxDayChampionnat(m);

        if (day > maxDayChampionnat) {
            day = maxDayChampionnat;
        }

        if (day < 1) {
            day = 1
        }

        setCurrentDay(day);
        parseMatch(m, day);
        return true;
    }

    return ( 
        <div className={"box_champ_component " + championnat}>
            <div className={"box_title " + championnat}>
                 <span>{getLongNameChamp(championnat)}</span>
            </div>
            <div className="box_onglet">
                <span className={currentOnglet == 1 ? "active" : ""} onClick={()=>setCurrentOnglet(1)}>Calendrier</span>
                <span className={currentOnglet == 2 ? "active" : ""} onClick={()=>setCurrentOnglet(2)}>Classement</span>
            </div>
            <div className="box_content" style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
                {
                    currentOnglet == 1 &&
                    <div className="box_calendar">
                        <div className="box_calendar_day">
                            <IoIosArrowUp className="box_day_arrow" size={22} style={{transform: 'rotate(-90deg)'}} onClick={()=>handleChangeDay(currentDay - 1)}/>
                            <span className={championnat}>Journée {currentDay}</span>
                            <IoIosArrowUp className="box_day_arrow" size={22} style={{transform: 'rotate(90deg)'}} onClick={()=>handleChangeDay(currentDay + 1)}/>
                        </div>
                        <div className="box_calendar_matchs" style={{width: '100%'}}>
                            {
                                parsedMatch.map((item,index) => {
                                    return (
                                        <div key={index} className="box_calendar_date">
                                            <span className={"box_calendar_date_span " + championnat}>{item.date.toLocaleDateString("fr-FR", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
                                            {
                                                item.dataIndex.map((data) => {
                                                    return (
                                                        <div key={data} style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 15, textAlign: 'center', width: '100%', marginBottom: 5}}>
                                                            <span className="box_calendar_equipe">{infoMatch(data, 'equa').split('1')[0]}</span> 
                                                            {
                                                                infoMatch(data, "scorea") !== "" && infoMatch(data, "scoreb") !== "" &&
                                                                <span className="box_calendar_time" style={{letterSpacing: 2}}>{infoMatch(data, 'scorea') + " - " + infoMatch(data, 'scoreb')}</span>
                                                                ||
                                                                <span className="box_calendar_time">VS</span>
                                                            }
                                                            
                                                            <span key={data} className="box_calendar_equipe">{infoMatch(data, 'equb').split('1')[0]}</span> 
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                }
                {
                    currentOnglet == 2 &&
                    <div className="box_classement">
                        <table className={championnat}>
                            <thead>
                                <tr>
                                    <td style={{width: '10%'}}>POS</td>
                                    <td style={{width: '81%'}}>Clubs</td>
                                    <td style={{width: '15%'}}>Pts</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    classement !== null &&
                                    classement.map((item, index) => {
                                        return (
                                            <tr>
                                                <td>{info(index, 'clt')}</td>
                                                <td>{info(index, 'equipe')}</td>
                                                <td className="td_pts">{info(index, 'pts')}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                        <span className={"box_span_details " + championnat} onClick={()=>navigate('/'+championnat+'/classement')}>Détails</span>
                    </div>
                }
            </div>
        </div>
    );
}

export default BoxChamp;